import { render, staticRenderFns } from "./Tab2.vue?vue&type=template&id=09b7335f&"
import script from "./Tab2.vue?vue&type=script&lang=js&"
export * from "./Tab2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports